
<section class="FirstScroll_Section">

<div class="mainHeader">
    <div class="LogoContainer">
        <img src="assets/images/AICTELogo.png" alt="Logo" class="logoImg">
        <img src="assets/images/SLALogo.png" alt="Logo" class="logoImg">
        <img src="assets/images/Parakhlogo.png" alt="Logo" class="logoImg" style="height: 47px;">
    </div>
    <div class="logoutBtnContainer">
        <button class="nav-item m-2 logoutButton" *ngIf="loggedIn" mat-raised-button
        (click)="logout($event)">Logout</button>
    </div>
</div>
<div class="formMainContainer">
  <div class="col-12 col-lg-12 col-md-12 col-sm-12 nopad formContainer mat-elevation-z8">
    <div class="col-lg-4 col-lg-4 col-md-4 col-sm-12 floatLeft grievanceLeftSection">
      <div class="h-100 contactListContainer">
          <ul class="contactList">
            <li>
              <div class="contacListDetails">
                <div class="mr-3 align-self-center">
                  <img src="./assets/images/ContactUs_Icons/icon1.png">
                </div>
                <div class="contactDetailContainer">
                  <h6 class="contactHeading font-weight-medium">Address</h6>
                  <p class="contactDetail">Nelson Mandela Marg,
                    <br> Vasant Kunj, New Delhi-110070</p>
                </div>
              </div>        
            </li>
            <li>
              <div class="contacListDetails">
                <div class="mr-3 align-self-center">
                  <img src="./assets/images/ContactUs_Icons/icon2.png">
                </div>
                <div class="contactDetailContainer">
                  <h6 class="contactHeading font-weight-medium">Phone</h6>
                  <p class="contactDetail">011-29581527<br><br></p>
                </div>
              </div>
            </li>
            <li>
              <div class="contacListDetails">
                <div class="mr-3 align-self-center">
                  <img src="./assets/images/ContactUs_Icons/icon3.png">
                </div>
                <div class="contactDetailContainer">
                  <h6 class="contactHeading font-weight-medium">Email</h6>
                  <p class="contactDetail">
                    parakh@aicte-india.org<br><br>
                    <!-- parakh@aicte-india.org<br><br> -->
                  </p>
                </div>
              </div>        
            </li>
          </ul>
      </div>
    </div>
    <div class="col-8 col-lg-8 col-md-8 col-sm-12 floatLeft halfpad pr-0">
      <div class="formCard p-2 h-100">
        <h2 class="formHeading">Grievance Form</h2>
        <form [formGroup]="grievanceForm" (ngSubmit)="onSubmit(grievanceForm.value)">
          <div class="row m-0">
            <div class="col-lg-4">
              <div class="form-group mt-2">
                <mat-form-field class="w-100" [floatLabel]="'never'" >
                  <mat-label>Name</mat-label>
                
                  <input matInput class="form-control" type="text" placeholder="name" formControlName="name" maxlength="100">
                <mat-error *ngIf="grievanceForm.controls.name.errors?.required">Name is required
                </mat-error>
                <mat-error *ngIf="grievanceForm.controls.name.errors?.minlength">Required (greater
                    than 3
                    characters)</mat-error>
                  </mat-form-field>
              </div>
            </div>
            <div class="col-lg-5">
              <div class="form-group mt-2">
                <mat-form-field class="w-100" [floatLabel]="'never'" >
                  <mat-label>Email</mat-label>
                  
                  <input matInput class="form-control" type="email" placeholder="email" formControlName="email" maxlength="100">
                  <mat-error *ngIf="grievanceForm.controls['email'].hasError('pattern')">Invalid Email
                    Address</mat-error>
                  </mat-form-field>
              </div>
            </div>
            <div class="col-lg-3">
              <div class="form-group mt-2">
                <mat-form-field class="w-100" [floatLabel]="'never'" >
                  <mat-label>Contact</mat-label>
                  
                  <input matInput class="form-control" type="text" placeholder="Contact"
                      (keypress)="checkPhoneNumber($event)" formControlName="phone" maxlength="10">

                  <mat-error *ngIf="grievanceForm.controls['phone'].hasError('minlength')">Mobile Number
                      should be of 10 numbers</mat-error>
                  <mat-error *ngIf="grievanceForm.controls['phone'].hasError('pattern')">Invalid Mobile Number
                  </mat-error>
              </mat-form-field>
              </div>
            </div>
            <div class="col-lg-12">
              <div class="form-group mt-2">
                <mat-form-field class="w-100" [floatLabel]="'never'" >
                  <mat-label>Nature</mat-label>
                  <mat-select style="padding: 7px;" placeholder="Nature" formControlName="nature">
                      <mat-option *ngFor='let nature of natures' [value]="nature['id']">{{nature['nature']}}</mat-option>
                  </mat-select>
                  <mat-error *ngIf="grievanceForm.controls['nature'].hasError('required')">Required</mat-error>
              </mat-form-field>
              </div>
            </div>

            <div class="col-lg-12">
              <div class="form-group mt-2">
                <mat-form-field class="w-100" [floatLabel]="'never'" >
                  <mat-label>Subject</mat-label>
                  <input matInput class="form-control" type="text" placeholder="subject" formControlName="subject">
                  <mat-error *ngIf="grievanceForm.controls['phone'].hasError('required')">Required</mat-error>
              </mat-form-field>
              </div>
            </div>
            <div class="col-lg-12">
              <div class="form-group mt-2">
                <mat-form-field class="w-100" [floatLabel]="'never'" >
                  <mat-label>Message</mat-label>
                  
                  <textarea matInput class="form-control" rows="5" placeholder="message" formControlName="message"></textarea>
                <mat-error *ngIf="grievanceForm.controls.message.errors?.required">Message is required
                </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-lg-12">
              <div class="form-group mt-2">
                <div fxFlex="45" class="custom-file">
                    <input type="file" class="custom-file-input" id="customFile" name="myfile" accept=".jpg, .jpeg, .png, .pdf"
                        (change)="uploadedFile($event)">
                    <label class="custom-file-label" for="customFile">{{fileInputLabel || 'Add Attachments (If any)'}}</label>
                </div>
              </div>
            </div>

            <div class="col-lg-12 submitBtnContainer">
              <button type="submit" class="btn submitBtn"><mat-icon matPreffix>send</mat-icon><span> SUBMIT</span></button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<!-- <div class="clearfix"></div>
<div class="container nopad mt-5 bt-5">
  <div class="row">
    <div class="col-lg-4 col-md-4 nopad">
      <div class="card-body d-flex align-items-center c-detail pl-0">
        <div class="mr-3 align-self-center">
          <img src="./assets/images/ContactUs_Icons/icon1.png">
        </div>
        <div class="">
          <h6 class="contactHeading font-weight-medium">Address</h6>
          <p class="">Nelson Mandela Marg,
            <br> Vasant Kunj, New Delhi-110070</p>
        </div>
      </div>
    </div>
    <div class="col-lg-4 col-md-4 nopad">
      <div class="card-body d-flex align-items-center c-detail">
        <div class="mr-3 align-self-center">
          <img src="./assets/images/ContactUs_Icons/icon2.png">
        </div>
        <div class="">
          <h6 class="contactHeading font-weight-medium">Phone</h6>
          <p class="">011-29581527<br><br></p>
        </div>
      </div>
    </div>
    <div class="col-lg-4 col-md-4 nopad">
      <div class="card-body d-flex align-items-center c-detail">
        <div class="mr-3 align-self-center">
          <img src="./assets/images/ContactUs_Icons/icon3.png">
        </div>
        <div class="">
          <h6 class="contactHeading font-weight-medium">Email</h6>
          <p class="">
            parakh[at]aicte[hyphen]india[dot]org<br><br>
          </p>
        </div>
      </div>
    </div>
  </div>
</div> -->
  
  
  
               

</section>

<div class="clearfix"></div>